export const timeline = [
  {
    period: "1970 年代",
    title: "从家庭内部写起",
    text: "这一时期大量作品把镜头对准婚姻、离婚与亲子关系，用日常冲突代替戏剧化巧合，家庭伦理成为独立题材的方向逐渐清晰。",
  },
  {
    period: "1980 年代",
    title: "中产生活的正面审视",
    text: "创作者开始更直接地拍中产家庭的沟通困境与代际差异，情节更依赖对话与人物状态，而非外部事件推动。",
  },
  {
    period: "1990 年代",
    title: "对话与内心戏的成熟",
    text: "以长对话构建关系的做法被广泛使用，作品更关注人物的内心变化，字幕翻译也随之成为理解人物语气的重要入口。",
  },
  {
    period: "2000 年代",
    title: "群像与多线索叙事",
    text: "多组人物、多线交错的叙事结构变多，社会议题与个人处境被放在同一张关系网里讨论，信息密度明显提高。",
  },
  {
    period: "2010 年代",
    title: "写实风格与个人视角",
    text: "手持摄影、自然光与克制表演成为常见手法，作品更愿意停在未解决的结局上，把判断留给观众。",
  },
  {
    period: "2020 年代",
    title: "重看与重新整理",
    text: "经典作品被反复重看、重译与整理成合集，中字高清的版本整理成为很多人了解这一类电影的入口。",
  },
];